// import Languages from '@/locales';
import {
  SORT_BY,
  DEVICE_TABS,
  parseJSON,
  SOLLAE_LOCAL_STORE,
  SOLLAE_BASE_URL,
  ERR_REQ_TIMEOUT,
  ERR_RES_INVALID,
  ERR_NETWORK_FAILED,
  getStorageItem,
  setStorageItem,
  buildUrl,
  // ERR_RES_UNEXPECTED,
} from '@/js/utils';
import Logger from '@/js/logger';

const { S_SORTBY, S_DEVICE_TAB } = SOLLAE_LOCAL_STORE;
const HTTP_OK = 200;
const HTTP_CREATED = 201;
const TIMEOUT = process.env.TIMEOUT_REST_API;
const API_PREFIX = process.env.API_PREFIX;
// const HTTP_UNAUTHORIZED       = 401;
// const HTTP_FORBIDDEN          = 403;
// const HTTP_NOT_FOUND          = 404;
// const HTTP_METHOD_NOT_ALLOWED = 405;
// const HTTP_SERVER_ERROR       = 500;
/*

export const changeLanguage = (language) => new Promise((resolve, reject) => {
  const inputLanguage = language || navigator.language || navigator.browserLanguage
  if (!isStr(inputLanguage)) reject(new Error('INVALID_LANGUAGE'));
  const supportedLanguages = Object.getOwnPropertyNames(Languages);
  const lang = supportedLanguages.find(lg => lg === inputLanguage.substring(0, 2));

  if (lang) {
    localStorage.setItem(S_LANGUAGE, lang);
    resolve(lang);
  }
  reject(new Error('UNIDENTIFIED_LANGUAGE'));
});

*/

export const changeSortby = (type) =>
  new Promise((resolve, reject) => {
    const sortby = parseInt(type);
    if (SORT_BY.map((t) => t.value).indexOf(sortby) !== -1) {
      localStorage.setItem(S_SORTBY, sortby);
      resolve(sortby);
    } else {
      reject(new Error('INVALID_SORT_REQUEST'));
    }
  });

export const fetchSortby = () =>
  Promise.resolve(parseInt(localStorage.getItem(S_SORTBY)) || 0);

export const changeDeviceTab = (tab) =>
  new Promise((resolve, reject) => {
    const deviceTab = parseInt(tab);
    if (DEVICE_TABS.map((t) => t.value).indexOf(deviceTab) !== -1) {
      localStorage.setItem(S_DEVICE_TAB, deviceTab);
      resolve(deviceTab);
    } else {
      reject(new Error('INVALID_DEVICE_TAB'));
    }
  });
export const fetchDeviceTab = () =>
  Promise.resolve(parseInt(localStorage.getItem(S_DEVICE_TAB)) || 0);

export const fetchUserData = () => getAPI(`${API_PREFIX}/users/me`);

export const fetchFrontendVersion = () =>
  getAPI(`${API_PREFIX}/common/frontend-version`);

export const fetchDevicesData = () => getAPI(`${API_PREFIX}/users/me/devices`);

export const fetchMqttInfo = () => getAPI(`${API_PREFIX}/users/me/mqtt`);

export const fetchPortsDataWithModel = (devModel, devId, isBatchMode) =>
  getAPI(
    `${API_PREFIX}/users/me/devices/${devModel.toLowerCase()}/${devId}`,
    isBatchMode
  );

export const removeDeviceOwnership = (devId) =>
  delAPI(`${API_PREFIX}/users/me/devices/${devId}`);

export const fetchLogDownloadLink = (devId) =>
  getAPI(`${API_PREFIX}/users/me/devices/${devId}/data`);

export const fetchDailyLogData = function (devId, date, isShareDevice = false) {
  return new Promise(function (resolve, reject) {
    // First, fetch the initial data containing the CSV URL
    getAPI(
      `${API_PREFIX}/users/me/${
        isShareDevice ? 'shared-' : ''
      }devices/${devId}/data/${date}`
    )
      .then(function (initialResponse) {
        // Since there's only one key, and it matches the date argument
        // const url = initialResponse[date];
        const firstKey = Object.keys(initialResponse)[0];
        const url = initialResponse[firstKey];
        if (!url) {
          Logger.warn('No daily log data found: ' + date);
          return resolve({ firstKey: '' });
        }

        // Check if hourly data is available
        const hourlyUrl = initialResponse.current_hour;

        // If hourly URL exists, fetch both in parallel; otherwise just fetch daily
        if (hourlyUrl) {
          Promise.all([fetchExternalUrl(url), fetchExternalUrl(hourlyUrl)])
            .then(function (results) {
              const dailyCsv = results[0];
              const hourlyCsv = results[1];

              // Merge hourly data: remove first line and append to daily
              let mergedCsv = dailyCsv;
              if (hourlyCsv) {
                const hourlyFirstNewline = hourlyCsv.indexOf('\n');
                if (hourlyFirstNewline !== -1) {
                  const hourlyContent = hourlyCsv.slice(hourlyFirstNewline + 1);
                  if (hourlyContent.trim()) {
                    mergedCsv += '\n' + hourlyContent;
                  }
                }
              }

              const result = {};
              result[date] = mergedCsv;
              resolve(result);
            })
            .catch(function (csvError) {
              Logger.error(
                'Error fetching log data for ' + date + ':',
                csvError
              );
              reject(csvError);
            });
        } else {
          // No hourly data, just fetch daily
          fetchExternalUrl(url)
            .then(function (csvContent) {
              const result = {};
              result[date] = csvContent;
              resolve(result);
            })
            .catch(function (csvError) {
              Logger.error(
                'Error fetching log data for ' + date + ':',
                csvError
              );
              reject(csvError);
            });
        }
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

export const fetchHourlyLogData = function (
  devId,
  date,
  hour,
  isShareDevice = false
) {
  return new Promise(function (resolve, reject) {
    // First, fetch the initial data containing the CSV URL
    getAPI(
      `${API_PREFIX}/users/me/${
        isShareDevice ? 'shared-' : ''
      }devices/${devId}/data/${date}/${hour}`
    )
      .then(function (initialResponse) {
        // Since there's only one key, and it matches the date argument
        // const url = initialResponse[date];
        const firstKey = Object.keys(initialResponse)[0];
        const url = initialResponse[firstKey];
        if (!url) {
          Logger.warn('No hourly log data found: ' + date + ' ' + hour);
          return resolve({ firstKey: '' });
        }

        // Fetch the CSV content from the full URL
        fetchExternalUrl(url)
          .then(function (csvContent) {
            const result = {};
            result[date + '_' + hour] = csvContent;
            resolve(result);
          })
          .catch(function (csvError) {
            Logger.error(
              'Error fetching hourly log data for ' + date + ' ' + hour + ':',
              csvError
            );
            reject(csvError);
          });
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

// Helper function to fetch external URLs (like S3)
function fetchExternalUrl(url) {
  return new Promise(function (resolve, reject) {
    const req = new XMLHttpRequest();
    req.open('GET', url, true);
    req.setRequestHeader('Accept', 'text/csv');

    /*
    const timer = setTimeout(function () {
      req.onload = null;
      req.onerror = null;
      reject(new Error(ERR_REQ_TIMEOUT));
    }, 20000);
    */

    req.onload = function () {
      // clearTimeout(timer);
      if (req.status === 200) {
        resolve(req.responseText);
      } else if (req.status === 404) {
        resolve('');
      } else {
        reject(
          new Error(ERR_RES_INVALID + ' - ' + req.status + ' HTTP_STATUS')
        );
      }
    };

    req.onerror = function () {
      // clearTimeout(timer);
      reject(new Error(ERR_NETWORK_FAILED));
    };

    req.send(null);
  });
}

export const updateModbusData = (devModel, devId, data) =>
  putAPI(
    `${API_PREFIX}/users/me/devices/${devModel.toLowerCase()}/${devId}`,
    data
  );

export const fetchModbusSlaveData = (devId) =>
  getAPI(`${API_PREFIX}/users/me/devices/${devId}/modbus-slaves`);

export const pushModbusSlaveData = (devId, data) =>
  postAPI(`${API_PREFIX}/users/me/devices/${devId}/modbus-slaves`, data);

export const updateModbusSlaveData = (devId, slaveID, data) =>
  putAPI(`${API_PREFIX}/users/me/modbus-slaves/${slaveID}`, data);

export const removeModbusSlaveData = (devId, slaveID) =>
  delAPI(`${API_PREFIX}/users/me/modbus-slaves/${slaveID}`);

export const fetchPkgwareInfo = (devId) =>
  getAPI(`${API_PREFIX}/users/me/devices/${devId}/pkgware`);

export const setUserInfo = (data) => putAPI(`${API_PREFIX}/users/me`, data);

export const setNotificationEmail = (data) =>
  putAPI(`${API_PREFIX}/users/me/notification-email`, data);

export const deleteMyUser = () => delAPI(`${API_PREFIX}/users/me`);

export const pushDevice = (data) =>
  postAPI(`${API_PREFIX}/users/me/devices`, data);

export const fetchSharedPortData = (portId, isBatchMode) =>
  getAPI(`${API_PREFIX}/users/me/ports/${portId}`, isBatchMode);

export const sendBatchRequest = (data) =>
  postAPI(`${API_PREFIX}/users/me/batch`, data);

export const fetchMyViewList = () => getAPI(`${API_PREFIX}/users/me/views`);

export const fetchSharedViewList = () =>
  getAPI(`${API_PREFIX}/users/me/shared-views`);

export const pushMyView = (data) =>
  postAPI(`${API_PREFIX}/users/me/views`, data);

export const fetchMyView = (viewId) =>
  getAPI(`${API_PREFIX}/users/me/views/${viewId}`);

export const removeMyView = (viewId) =>
  delAPI(`${API_PREFIX}/users/me/views/${viewId}`);

export const fetchFullView = (viewId) =>
  getAPI(`${API_PREFIX}/users/me/views/${viewId}`);

export const updateMyView = (viewId, data, isBatchMode) =>
  putAPI(`${API_PREFIX}/users/me/views/${viewId}`, data, isBatchMode);

export const pushViewPage = (viewId, data, isBatchMode) =>
  postAPI(`${API_PREFIX}/users/me/views/${viewId}/pages`, data, isBatchMode);

export const fetchViewPage = (viewId, pageId, isBatchMode) =>
  getAPI(`${API_PREFIX}/users/me/pages/${pageId}`, isBatchMode);

export const fetchViewPageAll = (viewId, isBatchMode) =>
  getAPI(`${API_PREFIX}/users/me/views/${viewId}/pages`, isBatchMode);

export const updateViewPage = (viewId, pageId, data, isBatchMode) =>
  putAPI(`${API_PREFIX}/users/me/pages/${pageId}`, data, isBatchMode);

export const removeViewPage = (viewId, pageId, isBatchMode) =>
  delAPI(`${API_PREFIX}/users/me/pages/${pageId}`, isBatchMode);

export const pushPageItem = (viewId, pageId, data, isBatchMode) =>
  postAPI(`${API_PREFIX}/users/me/pages/${pageId}/items`, data, isBatchMode);

export const pushPageBackground = (
  viewId,
  pageId,
  { data, contentType },
  isBatchMode
) =>
  postAPI(
    `${API_PREFIX}/users/me/pages/${pageId}/images`,
    data,
    isBatchMode,
    contentType
  );

export const pushUserImage = ({ data, contentType }, isBatchMode) =>
  postAPI(
    `${API_PREFIX}/users/me/studio/images`,
    data,
    isBatchMode,
    contentType
  );

export const fetchUserImages = (isBatchMode) =>
  getAPI(`${API_PREFIX}/users/me/studio/images`, isBatchMode);

export const removeUserImage = (imageId, isBatchMode) =>
  delAPI(`${API_PREFIX}/users/me/studio/images/${imageId}`, isBatchMode);

export const fetchImageCategories = (isBatchMode) =>
  getAPI(`${API_PREFIX}/common/studio/common-images/categories`, isBatchMode);

export const fetchCategoryImages = (categoryId, isBatchMode) =>
  getAPI(
    `${API_PREFIX}/common/studio/common-images/categories/${categoryId}`,
    isBatchMode
  );

export const removePageBackground = (viewId, pageId, isBatchMode) =>
  delAPI(`${API_PREFIX}/users/me/pages/${pageId}/images`, isBatchMode);

export const fetchPageItem = (viewId, pageId, itemId, isBatchMode) =>
  getAPI(`${API_PREFIX}/users/me/items/${itemId}`, isBatchMode);

export const fetchPageItemAll = (viewId, pageId, isBatchMode) =>
  getAPI(`${API_PREFIX}/users/me/pages/${pageId}/items`, isBatchMode);

export const updatePageItem = (viewId, pageId, itemId, data, isBatchMode) =>
  putAPI(`${API_PREFIX}/users/me/items/${itemId}`, data, isBatchMode);

export const removePageItem = (viewId, pageId, itemId, isBatchMode) =>
  delAPI(`${API_PREFIX}/users/me/items/${itemId}`, isBatchMode);

export const fetchShareUserStudio = (viewId, isBatchMode) =>
  getAPI(`${API_PREFIX}/users/me/views/${viewId}/shared-users`, isBatchMode);

export const pushShareUserStudio = (viewId, data, isBatchMode) =>
  postAPI(
    `${API_PREFIX}/users/me/views/${viewId}/shared-users`,
    data,
    isBatchMode
  );

export const removeShareUserStudio = (viewId, shareId, isBatchMode) =>
  delAPI(`${API_PREFIX}/users/me/shared-views/${shareId}`, isBatchMode);

export const removeShareStudio = (viewId, shareId, isBatchMode) =>
  delAPI(`${API_PREFIX}/users/me/shared-views/${shareId}`, isBatchMode);

export const fetchShareUserDeviceList = () =>
  getAPI(`${API_PREFIX}/users/me/shared-devices`);

export const fetchShareUserDevice = (devId, isBatchMode) =>
  getAPI(`${API_PREFIX}/users/me/devices/${devId}/shared-users`, isBatchMode);

export const fetchSharedPortsDataWithModel = (devModel, devId, isBatchMode) =>
  getAPI(
    `${API_PREFIX}/users/me/shared-devices/${devModel.toLowerCase()}/${devId}`,
    isBatchMode
  );

export const pushShareUserDevice = (devId, data, isBatchMode) =>
  postAPI(
    `${API_PREFIX}/users/me/devices/${devId}/shared-users`,
    data,
    isBatchMode
  );

export const removeShareUserDevice = (shareId, isBatchMode) =>
  delAPI(`${API_PREFIX}/users/me/shared-devices/${shareId}`, isBatchMode);

export const fetchAnnouncementList = (isBatchMode) => {
  const url = buildUrl(`${API_PREFIX}/public/notifications`, {
    noti_state: 1,
  });
  return getAPI(url, isBatchMode);
};

function getAPI(relative_url, isBatchMode) {
  const req = { method: 'GET', relative_url, body: '', passcode: [HTTP_OK] };
  return isBatchMode ? req : sendRequest(req);
}

function isNonStringifiable(data) {
  return data instanceof FormData || typeof data === 'string';
}

function postAPI(relative_url, data, isBatchMode, customContentType) {
  const req = {
    method: 'POST',
    relative_url,
    body:
      isBatchMode || isNonStringifiable(data) || customContentType
        ? data
        : JSON.stringify(data || ''),
    passcode: [HTTP_OK, HTTP_CREATED],
    customContentType,
  };
  return isBatchMode ? req : sendRequest(req);
}

function putAPI(relative_url, data, isBatchMode) {
  const req = {
    method: 'PUT',
    relative_url,
    body:
      isBatchMode || isNonStringifiable(data)
        ? data
        : JSON.stringify(data || ''),
    passcode: [HTTP_OK],
  };
  return isBatchMode ? req : sendRequest(req);
}

function delAPI(relative_url, isBatchMode) {
  const req = { method: 'DELETE', relative_url, body: '', passcode: [HTTP_OK] };
  return isBatchMode ? req : sendRequest(req);
}

function sendRequest(request) {
  // Return a new promise.
  // Do the usual XHR stuff
  return new Promise((resolve, reject) => {
    let params;
    try {
      params = parseJSON(getStorageItem(process.env.ACCESS_TOKEN_KEY));
    } catch (err) {
      params = null;
    }
    if (!params || !params.id_token) {
      if (
        window.location.pathname.startsWith('/studio/') ||
        window.location.pathname.startsWith('/dashboard/')
      ) {
        setStorageItem(process.env.LAST_URL_KEY, window.location.pathname);
        return location.replace(process.env.SIGNIN_URL);
      }
      return location.replace('/en');
    }

    const req = new XMLHttpRequest();

    req.open(request.method, SOLLAE_BASE_URL + request.relative_url);
    req.setRequestHeader('Authorization', params.id_token);
    if (request.method === 'POST' || request.method === 'PUT') {
      if (!request.customContentType) {
        req.setRequestHeader('Content-Type', 'application/json');
      } else {
        if (typeof request.customContentType === 'string') {
          req.setRequestHeader('Content-Type', request.customContentType);
        }
      }
    }
    const timer = setTimeout(() => {
      if (req) {
        req.onload = null;
        req.onerror = null;
      }
      Logger.info(
        '[HTTP Req]',
        `${request.method} ${JSON.stringify(
          request.body || request.relative_url
        )},
          'Timeout: ${TIMEOUT / 1000}s'`
      );

      reject(new Error(ERR_REQ_TIMEOUT));
    }, TIMEOUT);

    req.onload = function () {
      // This is called even on 404 etc
      // so check the status
      clearTimeout(timer);
      let res = '';
      try {
        if (!(request.method === 'DELETE' && req.response === '')) {
          res = parseJSON(req.response);
        }
      } catch (e) {
        res = req.response;
        Logger.info(
          request.method +
            ' ' +
            JSON.stringify(request.body || request.relative_url),
          'HTTP Response',
          res
        );
      }
      Logger.info(
        '[HTTP Res]',
        request.method +
          ' ' +
          JSON.stringify(request.body || request.relative_url)
      );
      Logger.info('[HTTP Res]', res, 'Status', req.status);

      if (request.passcode.indexOf(req.status) !== -1 && !res.error) {
        // Resolve the promise with the response text
        resolve(res);
      } else {
        if (req.status === 401) {
          if (
            window.location.pathname.startsWith('/studio/') ||
            window.location.pathname.startsWith('/dashboard/')
          ) {
            setStorageItem(process.env.LAST_URL_KEY, window.location.pathname);
            return location.replace(process.env.SIGNIN_URL);
          }
          return location.replace('/en');
        }
        if (res.error) reject(new Error(res.error.code));
        else {
          reject(
            new Error(ERR_RES_INVALID + ' - ' + req.status + ' HTTP_STATUS')
          );
        }
      }
    };

    // Handle network errors
    req.onerror = function () {
      clearTimeout(timer);
      // EventBus.$emit('test-api', { req: request.method + ' ' + JSON.stringify(request.data || request.relative_url), res: ERR_NETWORK_FAILED })
      reject(new Error(ERR_NETWORK_FAILED));
    };

    // Make the request
    req.send(request.body ? request.body : null);
  });
}
